const AI_TRANSFORM_CONFIGS = {
	AI_TRANSFORM_BULLET_POINTS: {
		name: "1538945",
		correlationId: "ai_transform_bullet_points",
	},
	AI_TRANSFORM_PRESENT_TENSE: {
		name: "1538945",
		correlationId: "ai_transform_present_tense",
	},
	AI_TRANSFORM_PAST_TENSE: {
		name: "1538945",
		correlationId: "ai_transform_past_tense",
	},
	AI_TRANSFORM_FIRST_PERSON: {
		name: "1538945",
		correlationId: "ai_transform_first_person",
	},
	AI_TRANSFORM_THIRD_PERSON: {
		name: "1538945",
		correlationId: "ai_transform_third_person",
	},
	AI_TRANSFORM_TRANSLATE: {
		name: "1538945",
		correlationId: "ai_transform_translate",
	},
	AI_TRANSFORM_REMOVE_GENDER: {
		name: "1538945",
		correlationId: "ai_transform_remove_gender",
	},
	AI_TRANSFORM_ANONYMIZE: {
		name: "1538945",
		correlationId: "ai_transform_anonymize",
	},
	AI_TRANSFORM_SPELLING_GRAMMAR: {
		name: "1538945",
		correlationId: "ai_transform_spelling_grammar",
	},
	AI_TRANSFORM_IMPROVE_STYLE: {
		name: "1538945",
		correlationId: "ai_transform_improve_style",
	},
} as const

const AI_SIDEBAR_CONFIGS = {
	AI_JOB_DESCRIPTION: {
		name: "1732420",
		correlationId: "ai_job_description",
	},
	AI_CANDIDATE_INFO: {
		name: "1732423",
		correlationId: "ai_candidate_info",
	},
	AI_LANDING_PAGES: {
		name: "1732430",
		correlationId: "ai_landing_pages",
	},
	AI_CONTENT: {
		name: "1732428",
		correlationId: "ai_content",
	},
} as const

const EMBED_CONFIGS = {
	EMBED_CALENDAR: {
		name: "1538984",
		correlationId: "embed_card",
	},
	EMBED_VIDEO: {
		name: "1538984",
		correlationId: "embed_video",
	},
} as const

export const TELEMETRY_CONFIG = {
	LOGIN_WITH_SSO: {
		name: "1576165",
		correlationId: "login_with_sso",
	},
	FIELD_MAPPING: {
		name: "1606193",
		correlationId: "field_mapping",
	},
	AI_TAG_UPDATES: {
		name: "1646034",
		correlationId: "ai_tag_updates", // TODO: currently TBC on method
	},
	CUSTOM_DATES: {
		name: "1732398",
		correlationId: "custom_dates",
	},
	CUSTOM_DOMAINS: {
		name: "1732402",
		correlationId: "custom_domains",
	},
	CANDIDATE_HEADSHOTS: {
		name: "1732406",
		correlationId: "candidate_headshots",
	},
	AI_TAG_BUILDER: {
		name: "1732411",
		correlationId: "ai_tag_builder",
	},
	PLACEHOLDER_TAG_BUILDER: {
		name: "1732413",
		correlationId: "placeholder_tag_builder",
	},
	TEMPLATE_LIBRARY: {
		name: "1732416",
		correlationId: "template_library",
	},
	ORIGINAL_CV: {
		name: "1732418",
		correlationId: "original_cv",
	},
	...AI_TRANSFORM_CONFIGS,
	...AI_SIDEBAR_CONFIGS,
	...EMBED_CONFIGS,
} as const
